const invalidClassName = 'input-invalid'
const data = {}

const validationService = (target) => {
    if(target.validity.valueMissing || target.validity.typeMismatch){
        target.classList.add(invalidClassName)
    }else{
        target.classList.remove(invalidClassName)
    }
}

const inputValidation = ({currentTarget}, key)=> {
    switch(key){
        case 'i':
            validationService(currentTarget) 
            break;
        case 'u':
            if(!data[`isFirstUnblur${currentTarget.id}`]){
                data[`isFirstUnblur${currentTarget.id}`] = true
                validationService(currentTarget)
            } 
            break
        default:
            break;
    }    
}

const bindValidation = (inputEl) => {
    if (!inputEl) return
    inputEl.addEventListener('input', (event) => inputValidation(event, 'i'))
    inputEl.addEventListener('blur', (event) => inputValidation(event, 'u'))
}

const setup = () => {
    bindValidation(document.querySelector('#email'))
    bindValidation(document.querySelector('#password'))
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup)
} else {
    setup()
}